import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/web/talenzap/node_modules/next/dist/client/app-dir/link.js");
